type IdType = number|string;
export function idToIri(id: IdType, resourceNamePlural: string):string {
    return `/api/v1/${resourceNamePlural}/${id}`;
}

export function idsToIri(ids: IdType|IdType[], resourceNamePlural: string):string[]{
    if (!ids) {
        return [];
    }
    if (!Array.isArray(ids)){
        return [idToIri(ids, resourceNamePlural)];
    }

    return ids.map(id => idToIri(id, resourceNamePlural));
}

export function iriToId(iri?: string | null): string | undefined {
    return iri?.split('/').pop();
}

type IdRef = IdType | {id?: IdType | null} | null | undefined;

const refToId = (item: IdRef): IdType | null | undefined => {
    if (item === null || item === undefined) {
        return undefined;
    }

    return typeof item === 'object' ? item.id : iriToId(`${item}`);
};

export const normalizeIds = (items?: IdRef[] | null): string[] => (items ?? [])
    .map(refToId)
    .filter((id): id is IdType => id !== null && id !== undefined && id !== '')
    .map(id => `${id}`);
export const absoluteIri = (resourceName: string, id: number | string): string =>
    `${process.env.REACT_APP_BASE_API_URL}/${resourceName}/${id}`;
